import { useState } from 'react'

import { IconHome } from 'components/icons/home'
import { useDataContext } from 'context/data-context'
import { MenuItem } from './menu-item'
import { ToggleIcon } from './toggle-icon'
import {
  MenuList,
  MenuBackdrop,
  MenuToggle,
  MobileHidden,
  MobileOnly,
} from './styled'
import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'

export const Menu = () => {
  const { translate } = useDataContext()
  const isMobile = useMedia([breakpoints.sm], [true], false)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const toggleMenu = () => setIsMenuOpen((v) => !v)

  return (
    <>
      <MenuToggle onClick={toggleMenu} aria-label="Toggle menu">
        <ToggleIcon />
      </MenuToggle>
      {(isMenuOpen || !isMobile) && (
        <>
          {isMobile && <MenuBackdrop onClick={toggleMenu} />}
          <MenuList>
            <MenuItem href="/">
              <MobileHidden>
                <IconHome
                  aria-label={translate(
                    'Politically Motivated Cases in Kyrgyzstan'
                  )}
                />
              </MobileHidden>
              <MobileOnly>
                {translate('Politically Motivated Cases in Kyrgyzstan')}
              </MobileOnly>
            </MenuItem>
            <MenuItem href="/send-data">
              {translate('Send us more info title')}
            </MenuItem>
          </MenuList>
        </>
      )}
    </>
  )
}
